/**
 * Minicart component
 *
 * @module component-minicart
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "component-minicart";

if (!customElements.get(customElements.component)) {
  class ComponentMinicart extends HTMLElement {
    /**
     * Minicart web component
     *
     * @constructor
     */
    constructor() {
      super();

      window.theme.mini_cart = this;

      this._initCloseEvents();
      this._initOpenEvents();
    }

    /**
     * start to listen the click button to close minicart
     *
     * @returns {undefined}
     */
    _initCloseEvents() {
      // Close minicart when click on overlay
      document
        .querySelector("[data-minicart-close]")
        .addEventListener("click", (event) => {
          event.preventDefault();
          this._closeMinicart();
        });

      // Close minicart when click on close button
      this.querySelectorAll("[data-minicart-close-button]").forEach((btn) => {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          this._closeMinicart();
        });
      });

      // Close minicart on press escape
      window.addEventListener("escape", (event) => {
        this._closeMinicart();
      });
    }

    /**
     * hide minicart
     *
     * @returns {undefined}
     */
    _closeMinicart() {
      this.disableFocusTrap();

      document.querySelector("body").classList.remove("active-mini-cart");

      this.querySelector("[data-mini-cart-product-added]").classList.remove(
        "active"
      );

      // We need to use set time out to avoid issues with minicart animation
      setTimeout(() => {
        this.classList.remove("active");
        this.setAttribute("aria-hidden", "true");
        this.disableOverlay();
      }, 50);
    }

    /**
     * open minicart when clicking on bag
     *
     * @returns {undefined}
     */
    _initOpenEvents() {
      let openButton = document.querySelectorAll("[data-minicart-toggle]");

      openButton.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          if (!event.target.closest('.mini-cart__view-cart')) {
            event.preventDefault();
            this._openMinicart(0);
          }
        });
      });
    }

    /**
     * show minicart
     *
     * @param {integer} qty_added Product quantity added to the cart.
     * @returns {undefined}
     */
    _openMinicart(qty_added, overide = false) {
      let quantity = window.theme.cart.getCartQuantity();

      if (quantity > 0 || overide) {
        this._updateMinicartData(qty_added);

        document.querySelector("body").classList.add("active-mini-cart");

        document
          .querySelector("[data-mini-cart-product-added]")
          .classList.add("active");

        // We need to use set time out to avoid issues with minicart animation
        setTimeout(() => {
          this.classList.add("active");
          this.setAttribute("aria-hidden", "false");
          this.initFocusTrap();
          this.activeFocusTrap();
          this.enableOverlay();
        }, 50);
      }
    }

    /**
     * load all products in cart
     *
     * @param {integer} qty_added Product quantity added to the cart.
     * @returns {undefined}
     */
    _updateMinicartData(qty_added) {
      let component = this;

      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          component.loadItems(cart, qty_added);
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    /**
     * Enable minicart overlay
     *
     * @returns {undefined}
     */
    enableOverlay() {
      document.querySelector("[data-minicart-close]").classList.add("active");
      document.querySelector("[data-minicart-close]").focus();
    }

    /**
     * Disable minicart overlay
     *
     * @returns {undefined}
     */
    disableOverlay() {
      document
        .querySelector("[data-minicart-close]")
        .classList.remove("active");
    }

    /**
     * Update product added message
     *
     * @param {integer} qty_added Product quantity added to the cart.
     * @param {integer} id Product ID of product added to the cart.
     * @returns {undefined}
     */
    _updateProductAddedMessage(qty_added, id) {
      let message = this.querySelector(
        "[data-mini-cart-product-added-message]"
      );
      let messageWrapper = this.querySelector("[data-mini-cart-product-added]");

      if (!message) return false;

      if (qty_added == 0) {
        message.innerHTML = "";
        messageWrapper.classList.remove("active");
      } else if (qty_added == 1) {
        message.innerHTML = "<span>Item has been added to your cart</span>";
        messageWrapper.classList.add("active");
      } else {
        message.innerHTML = "<span>Items have been added to your cart</span>";
        messageWrapper.classList.add("active");
      }
    }

    /**
     * load all html products
     *
     * @param {integer} cart Cart object.
     * @param {integer} qty_added Product quantity added to the cart.
     * @returns {undefined}
     */
    loadItems(cart, qty_added) {
      // Removed April 8, 2024
      // this._updateProductAddedMessage(qty_added);
      // End remove
      var no_free_shipping = document.querySelector("[data-no_free_shipping]");

      if (cart.item_count > 0) {
        let div_items = this.querySelector("[data-mini-cart-items]");

        if (div_items) {
          let list_items = "";

          cart.items.forEach((item) => {
            console.log("Item:", item);
            let html_items = miniCartTemplate.mini_cart_items_layout;

            let item_url = item.url;

            html_items = html_items.replace(/{{itemKey}}/g, item.key);
            // Initialize a variable to hold the source of the image
            let image_src =
              "https://www.modularclosets.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif"; // Default placeholder

            // Check if the item has a 'designId' or equivalent in its properties
            const hasDesignId = item.properties && item.properties.designId;
            const designType = item.properties && item.properties._designType;

            console.log("hasDesignId", hasDesignId, "designType", designType);

            if (hasDesignId) {
              // If a designId is present, use the properties image if available
              const propertiesImage = item.properties._awsImage;
              if (propertiesImage) {
                image_src = propertiesImage.replace(".webp", "_150x150.webp");
              }
              if (designType === "17Squares") {
                item_url = `/pages/closet-design-tool?designId=${hasDesignId}`;
              } else if (designType === "Milano") {
                item_url = `/collections/milano?designId=${hasDesignId}#configurator`;
              } else if(designType === "designTool") {
                item_url = `/pages/design-tool?design-id=${hasDesignId}`;
              } else {
                console.log("Invalid design type:", designType);
              }
            } else {
              // No designId found, proceed with the original logic
              if (item.featured_image && item.featured_image.url) {
                // Use featured image if it exists
                image_src = item.featured_image.url
                  .replace(".jpg", "_150x150.jpg")
                  .replace(".png", "_150x150.png");
              } else if (item.image && item.image.url) {
                // Fallback to item.image if featured_image does not exist
                image_src = item.image.url
                  .replace(".jpg", "_150x150.jpg")
                  .replace(".png", "_150x150.png");
              }
              // If neither exists, the placeholder image will be used
            }

            html_items = html_items.replace(/{{itemImageSrc}}/g, image_src);

            let random_number = Math.floor(Math.random() * 10000) + 1;

            html_items = html_items.replace(/{{randomNumber}}/g, random_number);
            // Products Title
            if (item.product_title) {
              let item_title;
              if (item.product_has_only_default_variant) {
                item_title = item.title;
              } else {
                item_title = item.product_title;
              }

              html_items = html_items.replace(/{{itemUrl}}/g, item_url);
              html_items = html_items.replace(/{{itemTitle}}/g, item_title);
            }

            if (item.sku) {
              let item_sku = item.sku;
              html_items = html_items.replace(/{{itemSku}}/g, item_sku);
            }

            // Variant Title
            if (!item.product_has_only_default_variant) {
              let html_options = "";

              item.options_with_values.forEach((options) => {
                html_options +=
                  "<div class='mini-cart__item-options'>" +
                  options.name +
                  ": " +
                  options.value +
                  "</div>";
              });

              html_items = html_items.replace(/{{itemOptions}}/g, html_options);
            } else {
              let html_options = "";
              html_items = html_items.replace(/{{itemOptions}}/g, html_options);
            }

            let item_id = item.id;
            html_items = html_items.replace(/{{itemID}}/g, item_id);

            // Variant Price
            // if(item.final_line_price) {
            let item_price = window.theme.money.format(item.final_line_price);

            html_items = html_items.replace(/{{itemPrice}}/g, item_price);
            // }

            // Variant quantity

            if (item.has_components) {
              // Replace quantity selector with a link button for items with components
              let linkButtonHTML = `
                <a href='${item_url}' class='edit-item-link' data-edit-item-id='${hasDesignId}'>
                  Edit design
                </a>
              `;

              html_items = html_items.replace(
                /<quantity-selector[\s\S]*?<\/quantity-selector>/,
                linkButtonHTML
              );
            } else {
              // Keep the item quantity if it does not have components
              let item_quantity = item.quantity;
              html_items = html_items.replace(
                /{{itemQuantity}}/g,
                item_quantity
              );
            }

            list_items += html_items;
          });

          if (list_items) {
            div_items.innerHTML = list_items;

            //Listen when update the input quantity
            this._initListenQuantity();

            //Update count icon
            window.theme.cart._setCartQuantity(cart.item_count);

            //Update all prices inside minicart
            this._uploadAllMinicartPrices(cart);

            //Set the height proportional to the footer
            let footer = this.querySelector("[data-minicart-footer]");
            let messageWrapper = this.querySelector(
              "[data-mini-cart-product-added]"
            );
            let sum = footer.offsetHeight + messageWrapper.offsetHeight;

            div_items.style.height = "calc(100vh - " + (sum + 80) + "px)";

            //Init the event when delete a product
            this._initListenTrashButton();
          }
        }
      } else {
        this._closeMinicart();
        if (no_free_shipping) {
          no_free_shipping.innerHTML =
            '<span class="alert-message__title" data-no_free_shipping>Just ' +
            window.theme.money.format(100000) +
            " away from free shipping</span>";
        }

        //Update count icon
        window.theme.cart._setCartQuantity(0);
      }
    }

    /**
     * Listen when update the input quantity
     *
     * @returns {undefined}
     */
    _initListenQuantity() {
      document
        .querySelectorAll("[data-cart-page-item-id]")
        .forEach((element) => {
          element.addEventListener("change", (event) => {
            event.preventDefault();
            var productId = event.target.dataset.cartPageItemId;

            if (productId) {
              this._updateMiniCart(productId, event.target.value);
            }
          });
        });
    }

    /**
     * Update the minicart
     *
     * @returns {undefined}
     */
    _updateMiniCart(id, qty) {
      let component = this;
      return new Promise((resolve, reject) => {
        // Create the request
        let request = {
          method: "POST",
          headers: {
            "Content-Type": "application/json;",
          },
          body: JSON.stringify({
            id: id,
            quantity: qty,
          }),
        };

        // Make a request
        fetch("/cart/change.js", request)
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            if (json.status && json.status !== 200) {
              var error = new Error(json.description);
              error.isFromServer = true;
              throw error;
            }

            component._updateMinicartData(0);
            component._checkAvailabilityStock(id, qty);

            resolve(true);
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    }

    /**
     * check if product has unavailability stock
     *
     * @returns {undefined}
     */
    _checkAvailabilityStock(id, qty_added) {
      let message = this.querySelector("[data-error-message]");

      if (!message) return false;

      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          cart.items.forEach((item) => {
            if (id == item.id) {
              if (qty_added > item.quantity) {
                message.innerHTML = "";
                message.append(
                  "All " +
                    item.quantity +
                    " " +
                    item.title +
                    " are in your cart."
                );
                message.classList.add("active");

                let input = document.querySelector(
                  '[data-cart-page-item-id="' + item.id + '"]'
                );

                if (input) {
                  input.value = item.quantity;
                }
              } else {
                message.innerHTML = "";
                message.classList.remove("active");
              }
            }
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    /**
     * Updates an item's quantity in the cart. To remove an item, set the quantity to 0.
     * This function is designed to work with e-commerce platforms that allow cart manipulation via API.
     *
     * @param {string} itemKey The unique key of the item in the cart.
     * @param {number} quantity The new quantity for the item. Set to 0 to remove the item.
     * @param {function} callback An optional callback function to execute after the item has been updated. The callback will receive two arguments: an error (if any) and the response data.
     */
    _updateCartItem(itemKey, quantity = 0, callback) {
      let component = this; // Assuming 'this' is correctly bound to your component

      fetch(`/cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: quantity,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Cart update successful", data);

          // Assuming _updateMinicartData should be called regardless of callback's existence
          component._updateMinicartData(data); // Pass the updated cart data if needed

          // Checking and calling the callback function if it's provided
          if (typeof callback === "function") {
            callback(null, data); // Call the callback with no error and the updated cart data
          }
        })
        .catch((error) => {
          console.error("Error updating cart item:", error);
          if (typeof callback === "function") {
            callback(error); // Call the callback with the error
          }
        });
    }

    /**
     * Listen when click in remove item
     *
     * @returns {undefined}
     */
    _initListenTrashButton() {
      document
        .querySelectorAll("[data-minicart-remove-item]")
        .forEach((element) => {
          element.addEventListener("click", (event) => {
            event.preventDefault();

            var productId = element.dataset.minicartVariantId;
            var VariantTitle = element.dataset.minicartVariantTitle;
            var itemKey = element.dataset.minicartItemKey;
            console.log("element.dataset", element.dataset);

            if (productId) {
              // this._updateMiniCart(productId, 0);
              this._updateCartItem(itemKey);
            }
          });
        });
    }

    /**
     * Upload all components inside minicart as prices, numbers, etc
     *
     * @param {cart} cart A cart object.
     * @param {id} id A cart id.
     * @returns {undefined}
     */
    _uploadAllMinicartPrices(cart, id) {
      if (id) {
        cart.items.forEach((item) => {
          if (id == item.id) {
            var total_per_product = window.theme.money.format(
              item.final_line_price
            );

            document
              .querySelectorAll("[data-minicart-item-id='" + item.id + "']")
              .forEach((element) => {
                //Updating price item inside minicart
                element.innerText = total_per_product;
              });
          }
        });
      }

      // Updating total at the top
      var total1 = document.querySelector("[data-mini-cart-total1]");
      if (total1) {
        total1.innerHTML =
          "Order Total: <strong>" +
          window.theme.money.format(cart.total_price) +
          "</strong>";
      }

      // Updating total at the bottom
      var total2 = document.querySelector("[data-minicart-total2]");
      if (total2) {
        total2.innerHTML =
          "Order Total: <strong class='test'>" +
          window.theme.money.format(cart.total_price) +
          "</strong>";
      }

      // Updating subtotal
      var subtotal = document.querySelector("[data-minicart-subtotal]");

      var subtotalAmount = cart.items_subtotal_price;
      // var no_free_shipping = document.querySelector("[data-no_free_shipping]");
      // if (subtotalAmount < 99999 && subtotalAmount > 1) {
      //   no_free_shipping.innerHTML =
      //     '<span class="alert-message__title" data-no_free_shipping>Just ' +
      //     window.theme.money.format((subtotalAmount - 100000) * -1) +
      //     " away from free shipping</span>";
      // } else {
      //   no_free_shipping.innerHTML =
      //     '<span class="alert-message__title" data-yes_free_shpping>FREE SHIPPING unlocked!</span>';
      // }

      // if (subtotal) {
      //   subtotal.innerHTML = window.theme.money.format(
      //     cart.items_subtotal_price
      //   );
      // }
      setTimeout(function () {
        var app_shipping_costs = document.querySelectorAll(
          ".docapp-free-shipping-price"
        );
        console.log(
          "app_shipping_cost elements after 2 seconds:",
          app_shipping_costs
        );

        // Check if the subtotal amount is within the specified range
        if (subtotalAmount > 1400) {
          // Calculate 12% of the cart value
          var discountAmount = subtotalAmount * 0.12;

          // Ensure the discount amount is within $10 and $150
          discountAmount = Math.max(1000, discountAmount); // Not less than $10
          // discountAmount = Math.min(15000, discountAmount); // Not more than $150

          discountAmount = Math.ceil(discountAmount / 1000) * 1000;

          var formattedDiscount = window.theme.money.format(discountAmount);

          // Update each app_shipping_cost element
          app_shipping_costs.forEach(function (app_shipping_cost) {
            if (app_shipping_cost) {
              app_shipping_cost.innerHTML = "<s>" + formattedDiscount + "</s>";
              app_shipping_cost.style.visibility = "visible";
              console.log(
                "Updated app_shipping_cost to show crossed out amount within $10 - $150 range:",
                formattedDiscount
              );
            }
          });
        }
      }, 250); // 250 milliseconds
      // Emit a custom event when the mini cart is fully active
      const event = new CustomEvent("minicartUpdated", {
        detail: {
          message: "Mini cart updated",
          time: new Date(),
        },
        bubbles: true, // This event should bubble up through the DOM
        cancelable: true,
      });

      this.dispatchEvent(event);
    }

    /**
     * Init minicart focus trap
     *
     * @returns {undefined}
     */
    initFocusTrap() {
      this.focusTrap = focusTrap.createFocusTrap(this, {
        clickOutsideDeactivates: true,
      });
    }

    /**
     * Ative minicart focus trap
     *
     * @returns {undefined}
     */
    activeFocusTrap() {
      if (this.focusTrap) {
        this.focusTrap.activate();
      }
    }

    /**
     * Disable minicart focus trap
     *
     * @returns {undefined}
     */
    disableFocusTrap() {
      if (this.focusTrap) {
        this.focusTrap.deactivate();
      }
    }
  }

  customElements.define(customElements.component, ComponentMinicart);
}
